import { render, staticRenderFns } from "./PopularSportsResult.vue?vue&type=template&id=6f4169ca&"
import script from "./PopularSportsResult.vue?vue&type=script&lang=js&"
export * from "./PopularSportsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports